export const avatarBg = () =>
  localStorage.getItem("app_mode") === "dluxe" ? "e11d48" : "7c3aed";
